function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowsquareright(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 21.25h15a1.502 1.502 0 001.5-1.5v-15a1.502 1.502 0 00-1.5-1.5h-15A1.501 1.501 0 003 4.75v15a1.501 1.501 0 001.5 1.5zm7.538-5.287a.749.749 0 010-1.06L13.94 13H8.25a.75.75 0 110-1.5h5.69l-1.902-1.901a.75.75 0 011.06-1.06l3.181 3.18a.752.752 0 010 1.062l-3.18 3.182a.75.75 0 01-1.06 0z",
    fill: props.fill
  }));
}

export default SvgArrowsquareright;